//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    project: {
      type: Object,
      default: null,
    },
    tokens: {
      type: Array,
      default: null,
    },
    editDisabled: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      limit: 9,
      overlay: false,
      selectedItem: null,
      sampleFile: null,
      selectedItemKey: null
    }
  },
  computed: {
    tokenList() {
      return this.limit ? this.tokens.slice(0,this.limit) : this.tokens
    },
    fullRes() {
      const { ipfsBaseUrl } = this.$config
      if (this.selectedItem) {
        return `${ipfsBaseUrl}/${this.selectedItem.hash}`
      }
      return null
    },
  },
  methods: {
    item(item, key) {
      console.log(item)
      if (!this.editDisabled) {
        document.getElementById('sampleFile').click()
      }
      else {
        this.overlay = !this.overlay
      }
      this.selectedItem = item
      this.selectedItemKey = key
    },
    async dropImage(e, item, key) {
      this.selectedItem = item
      this.selectedItemKey = key

      await this.upload(e.dataTransfer.files[0] instanceof File ? e.dataTransfer.files[0] : {}, true)
    },
    async upload(file, drop = false) {
      this.selectedItem.hash = null
      this.selectedItem.link = this.project.placeholder ?? "https://bad.src/not/valid"

      const formData = new FormData()
      if (drop) {
        formData.append("sample", file)
      }else {
        formData.set("sample", this.sampleFile instanceof File ? this.sampleFile : {})
      }
      formData.append('project_id', this.project.id)

      const res = await this.$axios({
        method: "PUT",
        url: `/api/sampletokens/${this.selectedItem.id}`,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${this.$store.state.token}`
        }
      })

      this.selectedItem.hash = res.data.hash
      this.selectedItem.link = res.data.link

      await this.$router.push({
        path: "/collections/" + this.project.slug
      });
    },
    deselectItem() {
      this.selectedItem = null
      this.overlay = false
    }
  }
}
